import styled from "styled-components";

export const StyledAppFormikFieldError = styled.div(({ theme }) => ({
  color: theme.error.main,
  fontSize: 12,
  minHeight: 14,
  marginLeft: "26px",
}));
